import React, { useState, useEffect} from "react";
import axios from "axios";
export default function BlogItem() {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  let baseURL = "https://fukuyamarccenter.com/item_view_for_json/";
  useEffect(() => {
    axios.post(
      baseURL,
      {
        action: "blog_item",
      },
      {
        headers: {
        'Content-Type': 'application/json',
        },
      }
      ).then((response) => {
        setData(response.data);
      }).catch((error) => {
        setError(error);
    });
    }, [baseURL]);
  function url_create(e){
    const currentUrl = window.location.href;
    return new URL(e, currentUrl).href;
  }
  if (!data) {
    return (
        <adide>Loading...</adide>
    );
  }

  return (
    <section>
        <h2 class="top_title_h2">商品入荷情報</h2>
        <div class="blog_item">
            {data.map((item) => (
            // eslint-disable-next-line no-template-curly-in-string
            <div className={`blog_item_child  ${item.item_state}` }>
                <div className="blog_item_child_date" dangerouslySetInnerHTML={{__html:item.date}} />
                <a href={item.url} >
                    <div className="blog_item_child_title" dangerouslySetInnerHTML={{__html:item.title}} />
                    <div dangerouslySetInnerHTML={{__html:item.sku_price}}/>
                    <div>
                       <div className="blog_item_child_img" dangerouslySetInnerHTML={{__html:item.img}} />
                        <div className="blog_item_child_content" dangerouslySetInnerHTML={{__html:item.content}}/>
                    </div>
                </a>
            </div>
            ))}
        </div>
        <div className="blog_item_link next_items"><a href={ url_create('blog_top') }>Blog 商品情報</a></div>
    </section>
    );
}
